import types from "../types/types";

//TODO: Fix default init objet for user.
const init = {
    type: types.user_credentials,
    user: {
            id: null,
    }    
}

export const userReducer = ( state = init, action ) => { 
    
    switch (action.type) {
        case types.user_credentials:            
            return {
                ...state,
                user: action.user,
            };
        // case types.restart_redux_on_logout:
        //     return {
        //         ...state,
        //         type: types.restart_redux_on_logout,
        //     };
        case types.user_token:
            return {
                ...state,
                token: action.token,
            };                    
        default:             
            return state;
    }
}
